<template>
  <v-stepper v-model="agentStep" class="stepper">
    <v-stepper-header class="stepper-alignment">
      <v-stepper-step :complete="agentStep > 1" :step="currentStep" class="py-1 py-md-2 display-16 ">{{ step1Text }}</v-stepper-step>

      <v-stepper-step :complete="agentStep > 2" step="2" class="py-1 py-md-2 display-16 ">{{ step2Text }}</v-stepper-step>
    </v-stepper-header>

    <DropDivider style="width: 60%;" />
    <v-stepper-items>
      <v-stepper-content step="1" class="pa-0">
        <Step1 />
      </v-stepper-content>

      <v-stepper-content step="2" class="pa-0">
        <Step2 />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>


<script>
import DropDivider from '@/components/DropDownMenu/DropDivider'
import Step1 from '@/components/Smart_Agent/Stepper/Step1'
import Step2 from '@/components/Smart_Agent/Stepper/Step2'
import { t } from '@/store/modules/homeDrushim/constantsContent'
import { mapState, mapActions } from 'vuex'
import CurrentUser from '@/components/mixins/CurrentUser'

export default {
  mixins: [CurrentUser],
  components: {
    Step1,
    Step2,
    DropDivider
  },

  data() {
    return {
      checkbox: false,
      agentStep: undefined,
      step1Text: t('titles.smartAgent.step1Text'),
      step2Text: t('titles.smartAgent.step2Text')
    }
  },
  computed: {
    ...mapState({
      currentStep: state => state.authUser.smartAgent.currentStep
    })
  },
  watch: {
    currentStep: {
      immediate: true,
      handler(newVal) {
        this.agentStep = newVal
      }
    }
  },

  mounted() {
    if (this.isLogged) {
      this.stepTwo()
    } else {
      this.agentStep = 1
    }
    this.$nuxt.$on('next-step', this.stepTwo)
  },
  beforeDestroy() {
    this.$nuxt.$off('next-step', this.stepTwo)
  },
  methods: {
    ...mapActions({
      setSmartAgentStep: 'setSmartAgentStep'
    }),
    stepTwo() {
      this.setSmartAgentStep(2)
      this.$bus.$emit('showOverlay')
    }
  }
}
</script>

<style lang="scss" scoped>
.stepper {
  margin: auto;
  box-shadow: none;
  border: none;
}

.stepper-alignment {
  justify-content: center;
  box-shadow: none;
}
</style>
